import { Line } from 'react-chartjs-2';
import { Chart, LineElement, CategoryScale, LinearScale, PointElement, Tooltip} from 'chart.js';

Chart.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip);

const CalculationsChart = ({ chartData, onHover }) => {

  const options = {
      responsive: true,
      maintainAspectRatio: false,
      animations: { radius: { duration: 0} },
      interaction: { intersect: false, mode: 'index' }, 
      plugins: { tooltip: false },
      scales: {
        x: {
          border: {
            display: false
          },
          grid: {
            display: false
          },
          ticks: {
            callback: function(value, index, values) {
              let divisor = (values.length-1) / 4;
              if (index % divisor === 0)
                return this.getLabelForValue(value);
            }
          }
        },
        y: { 
          border: {
            display: false
          },
          ticks: {
            maxTicksLimit: 10,
            callback: function(value) {
              return '$' + value.toLocaleString();
            }
          }
        }
      },
      elements: {
        point: {
          radius: 0,
          hoverRadius: 5
        }
      },
      onHover: (event, elements, chart) => {
        if (elements.length > 0) {
          const hoveredElement = elements[0];
          const datasetIndex = hoveredElement.datasetIndex;
          const index = hoveredElement.index;
          const segmentValue = chart.data.datasets[datasetIndex].data[index];
          const segmentRate = chart.data.datasets[datasetIndex].rates[index];
          const indexValue = chart.data.datasets[datasetIndex+1].data[index];
          const indexRate = chart.data.datasets[datasetIndex+1].rates[index];
          const label = chart.data.labels[index];
          onHover(segmentValue,segmentRate,indexValue,indexRate,label);
        }
      }
  };

  const verticalLinePlugin = {
    id: "verticalHoverLine",
    beforeDatasetsDraw: (chart) => {
      const { ctx, chartArea: {top, bottom} } = chart;

      ctx.save();
      chart.getDatasetMeta(0).data.forEach((dataPoint) => {
        if (dataPoint.active === true) {
          ctx.beginPath();
          ctx.strokeStyle = 'red';
          ctx.lineWidth = 1;
          ctx.setLineDash([5,5]);
          ctx.moveTo(dataPoint.x,top);
          ctx.lineTo(dataPoint.x,bottom);
          ctx.stroke();
        }
      })
    }
  };
  
  Chart.register(verticalLinePlugin);

  return (
    <Line style={{ height: '350px', marginBottom: '20px' }} data={chartData} options={options}/>
  )

};

export default CalculationsChart;